import { ApprovalsReviewKind } from './constants';
import { reviewKindToApprovalReviewStatus } from './reviewKindToApprovalReviewStatus';

export const getApprovalNotificationMessage = (reviewKind: ApprovalsReviewKind) => {
  if (reviewKind === ApprovalsReviewKind.COMMENT) {
    return 'Comment added successfully';
  }
  const reviewStatus = reviewKindToApprovalReviewStatus[reviewKind];
  return `Request ${reviewStatus}${reviewKind !== ApprovalsReviewKind.DECLINE ? ' successfully' : ''}`;
};
